import { Map } from "~/components/ui/map";
import {
  ActiveRequestMarkers,
  AvailabilityMapSummaryOverlay,
  UnitAvailabilityMarkers,
  UnitAvailabilityPolygons,
} from "./components";

export const AvailabilityMapPage = () => {
  return (
    <Map mapId={import.meta.env.VITE_AVAILABILITY_MAP_ID}>
      <UnitAvailabilityPolygons />
      <UnitAvailabilityMarkers />
      <ActiveRequestMarkers />
      <AvailabilityMapSummaryOverlay />
    </Map>
  );
};
